<template>
  <div>
    <button class="button back" @click="goBack">
      <font-awesome-icon :icon="['fas', 'chevron-left']" class="fa-xs" />
      Back
    </button>
    <h1>Disclaimer</h1>
    <p>
      Brave Bites is a self-tracking tool created to help individuals with ARFID during exposure therapy. It is intended for personal use only and does not offer medical advice, diagnosis, or treatment.
    </p>
    <p>
      Always consult a qualified healthcare professional for any medical or psychological concerns. This tool is not a replacement for professional care or therapy.
    </p>
    <h2>Helpful links</h2>
    <ul class="helpful-links-list">
      <li>
        <a target="_blank" href="https://www.arfidawarenessuk.org/">ARFID Awareness UK</a>
      </li>
      <li>
        <a target="_blank" href="https://www.reddit.com/r/ARFID/">ARFID Reddit Community</a>
      </li>
      <li>
        <a target="_blank" href="https://www.arfidcollaborative.com/welcome">ARFID Collaborative</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

.helpful-links-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
}

.helpful-links-list a {
  color: var(--primary-color);
}

.helpful-links-list a:hover {
  text-decoration: underline;
}

</style>
